import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import AppShell from './AppShell';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /**
   * Render without the app chrome. For screens that own the whole viewport —
   * onboarding, the post-checkout pages, and the fleet screens, which have
   * their own sidebar.
   */
  bare?: boolean;
}

export default function ProtectedRoute({ children, bare = false }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-bg">
        <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-brand" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // `from` is read back by LoginPage, so the person lands where they meant to
    // go rather than on Home.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // The shell is applied here rather than page by page: every protected screen
  // gets navigation by construction, and a new one cannot be added without it.
  return bare ? <>{children}</> : <AppShell>{children}</AppShell>;
}
